import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
    
import { IconButton, Tooltip, Grid, Checkbox, Typography, Paper, Button, Collapse, TextField } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import GetAppIcon from '@material-ui/icons/GetApp';

import { ThemeColors } from '../Theme'
import { PagedAgsUserList } from '../models/PagedAgsUserList';
import { Global } from '../models/Global'

import { RestComponent, PopupMenu } from 'react-frontend-utils' 
import { EditUserPopover } from '../components/EditUserPopover';
import { SetNewPasswordPopover } from '../components/SetNewPasswordPopover';




export class UsersListPage extends RestComponent {
  
    styles = {
        paperLabel: {
            marginLeft: 15,
            marginRight: 15,
            marginBottom: 5,
            color: 'gray',
            fontSize: '9pt',
            flexGrow: 1
        },
        paper: {
            padding: 0,
            marginBottom: 20
        },
        id: {
            marginLeft: 'auto',
            maxWidth: 300,
        },
        table: {
            borderCollapse: 'collapse',
            width: '100%',
            marginBottom: 10,
            marginTop: 10
        },
        tableHeader: {
            borderBottom: '2px solid ' + ThemeColors.appBarBackground,
            textAlign: 'left',
            paddingBottom: 5,
            paddingRight: 10,
            marginBottom: 8,
            fontSize: 13,
            color: ThemeColors.darkGray,
            fontWeight: 'normal',
            textTransform: 'uppercase'
        },
        tableDataWithBorder: {
            textAlign: 'left',
            fontSize: 13,
            paddingRight: 10,
            borderBottom: '1px solid lightGray'
        },
        tableData: {
            textAlign: 'left',
            fontSize: 14,
            marginRight: 10,
            verticalAlign: 'center'
        },
        role: {
            margin: 'auto',
            alignContent: 'center',
            width: 150,
            textTransform: 'uppercase',
            padding: 2, 
            borderRadius: 2, 
            color: 'white', 
            textAlign: 'center'
        },
       
    };
    
    
    constructor(props) {
        super(props);
    
        this.state.revealSet = new Set();         //Set of users to reveal detail

        this.state.usersPage = null;         //last fetched page - a PagedAgsUserList
        this.state.searchString = null;   
        this.state.searchAllDatabases = false;

        this.state.editUser = null;          //user to edit
        this.state.editUserPopoverOpen = false;

        this.state.setPasswordPopoverOpen = false;
        this.state.setPasswordUser = null;   
    }
    
    
    
    /**
     * When the page loads, immediately fetch the first page of users
     */
    componentDidMount() {
        super.componentDidMount();
        window.addEventListener("accountChangeEvent", this._accountHasChanged);
        
        //fetch all users, first page
        this._fetchUsers();  
    }
    
  
    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener("accountChangeEvent", this._accountHasChanged);
    }

    //callback when account has changed
    _accountHasChanged = () => {
        this._fetchUsers();  
    }
    
    
    //Fetch a specific page, using search fields if set.
    _fetchUsers = (page = 0) => {
        
        let queryString = "?";
        if (Global.accountID && !this.state.searchAllDatabases)
            queryString += "database=" + Global.getLastDatabase() + "&"; 

        if (this.state.searchString)
            queryString += "search=" + encodeURIComponent(this.state.searchString) + "&";

        queryString += "page=" + page;
        
        this.incrementBusy();
        this.secureJSONFetch("/act/users", {}, this._fetchUsersCallback, this._fetchErrorCallback, queryString); 
    }


    _exportUsers = () => {
        
        let queryString = "";
        if (Global.accountID && !this.state.searchAllDatabases)
            queryString += "?database=" + Global.getLastDatabase();

         if (this.state.searchString) {
            if (queryString.length === 0)
                queryString = "?";
            else
                queryString += "&";

            queryString += "search=" + encodeURIComponent(this.state.searchString);
        }
                  
        this.secureJSONFetch("/act/users/download", {method: "POST"}, this._exportUsersCallback, this._fetchErrorCallback, queryString); 
    }

    _exportUsersCallback = (response) => {
        this.showConfirmAlert("Export in Progress", "The report will be emailed to you in a few minutes.", 'green'); 
    }

    
    //Callback for fetching Transactions - response is json of PagedTransactionList
    _fetchUsersCallback = (response) => {
        if (response) {            
            const ul = new PagedAgsUserList(response);
            this.setState({usersPage: ul});
        }            
        this.decrementBusy();
    }
    

    _fetchErrorCallback = (error) => {
        this.showConfirmAlert("Error", error, 'red');
        this.decrementBusy();
    }

 
    //If the user is in the reveal list, remove it, if it is not, add it (toggle the user view)
    _revealUserDetail = (u) => {
        const toReveal = this.state.revealSet;
        
        if (toReveal.has(u))
            toReveal.delete(u);
        else
            toReveal.add(u);
        
        this.setState({revealSet: toReveal});
    }
    

 
    //fetch the previous page
    _prevPage = () => {  
        
        if (!this.state.usersPage || this.state.usersPage.isFirst())
            return;
        
        this._fetchUsers(this.state.usersPage.pageNo-1); 
        window.scrollTo(0, 0);  //jump to the top
    }
    
    //fetch the next page
    _nextPage = () => {  
        
        if (!this.state.usersPage || this.state.usersPage.isLast())
            return;
        
        this._fetchUsers(this.state.usersPage.pageNo+1); 
        window.scrollTo(0, 0);  //jump to the top
    }
    

    
    _search = () => {
        this._fetchUsers(0);
    }

    _getActionItems = (user) => {
       
        const actionItems = [];

        actionItems.push({label: "Edit User", selectCallback: () => {this._editUser(user);}, icon: null});
        actionItems.push({label: user.enabled ? "Disable User" : "Enable User", selectCallback: () => {this._enableUser(user);}, icon: null});
        actionItems.push({label: "Change Password", selectCallback: () => {this._changePassword(user);}, icon: null});
        actionItems.push({label: "Reset Password", selectCallback: () => {this._resetPassword(user);}, icon: null});
        actionItems.push({label: "Delete User", selectCallback: () => {this._deleteUser(user);}, icon: null});

        return actionItems;
    }

    _editUser = (user) => {
        this.setState({editUser: user, editUserPopoverOpen: true});
    }

    _userEdited = (user, isNew) => {
        this.incrementBusy();
        const method = isNew ? 'POST' : 'PUT';
        this.secureJSONFetch("/act/users", {method: method, body: user.toJSONforPost()}, this._userEditedCallback, this._fetchErrorCallback);
    }
    
    _userEditedCallback = (response) => {
        this.setState({editUser: null, editUserPopoverOpen: false});
        this.decrementBusy();
        this._fetchUsers(this.state.usersPage.pageNo); //refresh the page
    }

    _newUserButtonPressed = () => {
        this.setState({editUser: null, editUserPopoverOpen: true});
    }

    _changePassword = (user) => {
        this.setState({setPasswordUser: user, setPasswordPopoverOpen: true});
    }

    _doSetPassword = (password) => {
        this.setState({setPasswordPopoverOpen: false});
        const body = { newPassword: password };
        this.incrementBusy();
        this.secureJSONFetch("/act/users/" + this.state.setPasswordUser.id + "/password/change?provider=cognito", {method: 'POST', body: JSON.stringify(body)}, 
                            this._doSetPasswordPasswordCallback, this._fetchErrorCallback);
    }

    _doSetPasswordPasswordCallback = (response) => {
        console.log(response);
        this.decrementBusy();
        this.showConfirmAlert("Success", "Password changed. The user can login immediately with the new password.", 'green');
    }

    _resetPassword = (user) => {
        this.showConfirmAlert("Reset Password", "Are you sure you want to reset password for user \"" + user.fullName() + "\"? User will be sent a new temporary password by email which must be changed on next login.",
                                'black',
                                "Cancel",
                                () => this._doResetPassword(user),
                                "Reset Password",
                                'blue');
    }

    _doResetPassword = (user) => {
        this.incrementBusy();
        this.secureJSONFetch("/act/users/" + user.id + "/password/reset", {method: 'POST'}, this._resetPasswordCallback, this._fetchErrorCallback);
    }

    _resetPasswordCallback = (response) => {
        this.decrementBusy();
        this.showConfirmAlert("Success", "Password reset", 'green');
    }

    _enableUser = (user) => {

        const enable = user.enabled ? false : true;

        this.incrementBusy();
        this.secureJSONFetch("/act/users/" + user.id + "/enable?enable=" + enable, {method: 'POST'}, this._enableUserCallback, this._fetchErrorCallback);
    }

    _enableUserCallback = (response) => {
        this.decrementBusy();
        this._fetchUsers(this.state.usersPage.pageNo); //refresh the page
    }


    _deleteUser = (user) => {
        this.showConfirmAlert("Delete User", "Are you sure you want to delete user \"" + user.fullName() + "\"?",
                                'black',
                                "Cancel", 
                                () => this._doDeleteUser(user),
                                "Delete",
                                'red');
    }

    _doDeleteUser = (user) => {
        this.incrementBusy();
        this.secureJSONFetch("/act/users/" + user.id, {method: 'DELETE'}, this._deleteUserCallback, this._fetchErrorCallback);
    }

    _deleteUserCallback = (response) => {
        this.decrementBusy();
        this.setState({editUser: null, editUserPopoverOpen: false});
        this._fetchUsers(this.state.usersPage.pageNo); //refresh the page
    }

    
    //Render a row of the table with the specified User. In the User is null, render the header row
    _renderRow = (user, key) => {
        
        //Render the header
        if (!user) {
            return (
                <tr key={key} style={this.styles.tableStyle}>
                    <th style={{...this.styles.tableHeader, paddingRight: 0, width: '30px'}}/>
                    <th style={{...this.styles.tableHeader, width: 180}}>Name</th>
                    <th style={{...this.styles.tableHeader, width: 250, textAlign: 'center'}}>Role</th>
                    <th style={{...this.styles.tableHeader, width: 180}}>Email</th>
                    <th style={{...this.styles.tableHeader, paddingRight: 0, width: '30px'}}/>
                </tr>
            );
        }
      
      
        const isRevealed = this.state.revealSet.has(user);
        const leftIcon = isRevealed ? <ArrowDropDownIcon/> : <ArrowRightIcon/>;

        const columns = 7;      
                                
        return (
            <Fragment key={key}>
                <tr style={this.styles.tableStyle}>

                    <td style={this.styles.tableData}>
                        <IconButton edge="start" onClick={() => this._revealUserDetail(user)}>
                            {leftIcon}
                        </IconButton>
                    </td>

                    <td style={{...this.styles.tableData, color: user.enabled ? 'black' : 'red'}}>{user.fullName()}</td>

                    <td style={{...this.styles.tableData, textAlign: 'center'}}>
                        <Tooltip title={user.role.tooltip}>
                            <div style={{...this.styles.role, backgroundColor: user.role.color}}>
                                {user.role.label}
                            </div>
                        </Tooltip>
                    </td>

                    <td style={this.styles.tableData}>{user.email}</td>

                    <td style={{...this.styles.tableData, paddingRight: 0}}>
                        <div style={{display: 'flex', justifyContent: 'right'}}>                                        
                            <div style={{marginRight: 10}}/>
                            <PopupMenu menuIcon={(<SettingsIcon style={{fontSize: '20', color: ThemeColors.settingsOlive}}/>)}  
                                                menuItems={this._getActionItems(user)} 
                                                menuTooltipText={"Actions"}/>                         
                        </div>
                    </td>


                </tr>
                <tr style={this.styles.tableStyle}>
                    <td colSpan={columns} align='center' style={this.styles.tableDataWithBorder}>
                        <Collapse in={isRevealed}>
                            {user.renderDetail()}
                        </Collapse>
                    </td>
                </tr>
            </Fragment>
        );
    }
    
    
    //------------------------------- RENDER ----------------------------------------------
    
    render() {
       
                                
        const page = this.state.usersPage;
       
        const showing = (page && page.users.length > 0) ? "Displaying " + (page.index + 1) + "-" + (page.index + page.users.length) : null;            
                
        return (                        
             <Fragment>
                {this.getConfirmAlertComponent()}   

                {this.state.editUserPopoverOpen ?
                    <EditUserPopover user={this.state.editUser} isOpen={true}
                                    okCallback={this._userEdited}
                                    cancelCallback={() => {this.setState({editUserPopoverOpen: false});}}/>
                    : null
                }

                <SetNewPasswordPopover isOpen={this.state.setPasswordPopoverOpen} user={this.state.setPasswordUser}
                                       okCallback={(password) => this._doSetPassword(password)}    
                                       closeCallback={() => {this.setState({setPasswordPopoverOpen: false});}}
                />
                                      

                <Paper style={this.styles.paper}>
                    
                    <Button variant='outlined' style={{float: 'right', margin: 10, maxWidth: 200, color: ThemeColors.addColor}} onClick={this._newUserButtonPressed} component="label">
                        Add New User
                    </Button>

                    <Typography variant="body2" style={this.styles.paperLabel}>Search Users</Typography>  

                    {this.getBusyComponent('left', {marginLeft: 20, float: 'left'}, 30)}

                    <Grid container direction="row" spacing={3} style={{padding: 20}}>

                        <Grid item md={4} sm={12} xs={12}>
                            <Tooltip title="Search any part of last name, first name, or email">
                                <TextField label="Name/Email Search" inputProps={{style: {fontSize: 14}}}
                                           onChange={(event) => this.setState({searchString: event.target.value.trim()})} variant="outlined" fullWidth={true} InputLabelProps={{ shrink: true}} />
                            </Tooltip>
                        </Grid>

                         <Grid item md={4} sm={12} xs={12}>
                            <Tooltip title="Search all my Accounts (may be slower), otherwise just search the current Account">
                                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'start', marginLeft: 0}}>
                                        <Checkbox checked={this.state.searchAllDatabases} color='primary'
                                                    onChange={(event) => { this.setState({searchAllDatabases: event.target.checked})}}/>   
                                        <Typography variant='body2' align='left' style={{color: 'gray'}}>Include all my Accounts</Typography>   
                                </div>
                            </Tooltip>
                        </Grid>
                    </Grid>

                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Tooltip title="Search and Display Users below">
                            <Button fullWidth onClick={this._search} variant="outlined" color='primary' style={{margin: 20, maxWidth: 200}} component="label" startIcon={<SearchIcon />}>
                                Search
                            </Button>
                        </Tooltip>
                        <Tooltip title="Export Users to CSV File (file is emailed to you)">
                            <Button fullWidth onClick={this._exportUsers} variant="outlined" color='primary' style={{margin: 20, maxWidth: 200}} component="label" startIcon={<GetAppIcon />}>
                                Export
                            </Button>
                        </Tooltip>
                    </div>

                </Paper>
                
                <div style={{marginTop: 15}}/>
                
                {page ?
                     <div>   
                     
                        <table style={this.styles.table}>
                            <thead>
                               {this._renderRow(null, 0) /*render header*/ }
                            </thead>
                            <tbody>
                                {page.users.map((user, index) => this._renderRow(user, index+1))}
                            </tbody>
                        </table>
                        <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
                            <Typography variant="body2" style={{color: ThemeColors.darkGray}}>{showing}</Typography> 
                            <div style={{marginLeft: 'auto'}}>
                                {!page.isFirst() ? <Button onClick={this._prevPage} variant="outlined" color='primary' component="label" >
                                               Prev
                                           </Button>
                                           : null}

                                {!page.isLast() ? <Button onClick={this._nextPage} variant="outlined" color='primary' style={{marginLeft: 10}} component="label" >
                                               Next
                                           </Button>
                                           : null}
                            </div>            
                        </div>                        

                    </div>
                    
                    
                : null}
                
                
            </Fragment>
        );
        
    }
}



export default withCookies(withRouter(UsersListPage));

